module.exports = __webpack_public_path__ + "static/media/icon-phone.989e3a94.svg";